import React, { useEffect, useState, useContext } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";

import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { LanguageContext } from "App";

const SessionFacilitiesTable = ({ Session, RemoveFromSession }) => {
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: translations.TypeName, accessor: "TypeName" },
    { Header: translations.FacilityPagesCreatenewFacilityTypeCategory, accessor: "Category" },
    { Header: translations.Quantity, accessor: "Quantity" },
    { Header: translations.Remove, accessor: "Remove" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const MakeTableRow = (entry, type) => {
    return {
      TypeName: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {type.typeName}
        </MDTypography>
      ),
      Category: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {type.category}
        </MDTypography>
      ),
      Quantity: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {entry.quantityNeeded}
        </MDTypography>
      ),
      Remove: (
        <MDButton onClick={() => RemoveFromSession(entry.id)} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
        </MDButton>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((entry) => {
      rows.push(MakeTableRow(entry, entry.getFacility));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    RefreshTable(Session.getFacilities);
  }, []);

  return (
    <MDBox pt={3}>
      <DataTable
        table={{ columns: TableColumns, rows: TableDataRows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
    </MDBox>
  );
};

export default SessionFacilitiesTable;
